module.exports = __webpack_public_path__ + "img/120.f5245c38.jpg";